import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// Models
import { AuditedArea } from './../../shared/models/audited-area.model';
// Providers
import { AuditedAreaService } from '../../shared/services/audited-area.service';
import { PageStatusService } from './../../shared/services/page-status.service';

@Injectable()
export class AuditedAreaResolve implements Resolve<any> {
  constructor(
    private auditedAreaService: AuditedAreaService,
    private pageStatusService: PageStatusService,
    private translateService: TranslateService,
    private notificationsService: NotificationsService
  ) { }

  resolve (route: ActivatedRouteSnapshot): Promise<AuditedArea> {
    return this.auditedAreaService.getAuditedArea(route.params['auditedAreaId'])
      .catch(error => {
        switch (error.status) {
          case 404:
            this.fetchMessage404Translation()
              .then((translation: string) => {
                this.pageStatusService.goTo404(translation);
              });
            break;
        }
        this.fetchErrorTranslation()
          .then((translation: any) => {
            this.notificationsService.error(translation.title, translation.text);
          });
        return undefined;
      });
  }

  fetchMessage404Translation(): Promise<string> {
    return this.translateService.get('GLOBAL.ERROR.NOT_FOUND.AUDITED_AREA')
      .toPromise()
      .then((translation: string) => {
        return translation;
      });
  }

  fetchErrorTranslation(): Promise<any> {
    return this.translateService.get([
      'GLOBAL.ERROR.CONNECTION',
      'GLOBAL.ERROR.LOAD_AUDITED_AREA'
    ])
      .toPromise()
      .then((translation: Array<string>) => {
        return {
          title: translation['GLOBAL.ERROR.CONNECTION'],
          text: translation['GLOBAL.ERROR.LOAD_AUDITED_AREA']
        };
      });
  }
}
